export const DEFAULT_FINANCIAL_REPORT_EXECUTION_POLICY = Object.freeze({
    synchronousRowLimit: 500,
    asynchronousByDefault: true,
    cancellableStatuses: ['QUEUED', 'RUNNING', 'VALIDATING'],
    artifactFormats: ['CSV', 'JSON'],
    signedDownloadRequired: true,
    accessRevalidatedOnDownload: true,
    auditRequired: true,
    outboxRequired: true,
    lineageRequired: true,
    authoritativeMetadataRequired: true,
});
export function validateFinancialReportRequest(request) {
    const errors = [];
    if (!request.requestId.trim())
        errors.push('requestId is required');
    if (!request.reportId.trim())
        errors.push('reportId is required');
    if (!request.definitionVersion.trim())
        errors.push('definitionVersion is required');
    if (!request.parameterFingerprint.trim())
        errors.push('parameterFingerprint is required');
    if (!request.idempotencyKey.trim())
        errors.push('idempotencyKey is required');
    if (request.requestedFormats.length === 0)
        errors.push('at least one requested format is required');
    if (request.scopeKind === 'CLIENT' && !request.clientAccountId)
        errors.push('client scope requires clientAccountId');
    if (request.scopeKind === 'PORTFOLIO' && !request.portfolioAccountId)
        errors.push('portfolio scope requires portfolioAccountId');
    if (request.requestedByPersona === 'ORG_CLIENT' && !['CLIENT', 'PORTFOLIO'].includes(request.scopeKind)) {
        errors.push('organization client report requests must be client or portfolio scoped');
    }
    return errors;
}
export function validateFinancialReportArtifact(artifact) {
    const errors = [];
    if (!artifact.contentHash.trim())
        errors.push('contentHash is required');
    if (!artifact.storageObjectKey.trim())
        errors.push('storageObjectKey is required');
    if (!artifact.accessScopeFingerprint.trim())
        errors.push('accessScopeFingerprint is required');
    if (artifact.contentLength < 0)
        errors.push('contentLength cannot be negative');
    if (artifact.classification === 'CLIENT_VISIBLE' && !artifact.watermarkPolicyId) {
        errors.push('client-visible artifacts require a watermark policy');
    }
    return errors;
}
